// extracted by mini-css-extract-plugin
export default {"loader":"astronaut-loader_loader__3-te0"};